export default {
  path: '/:type/openSevice',
  auth: true,
  preload: false,
  key: 'openSevice',
  layout: 'inner', // outer 一级菜单 inner 二级菜单
  component: (props) => import('./index')
};
